import React from 'react';

export function HomeIcon(props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<rect x='1' y='1' width='38' height='38' rx='11' stroke='currentColor' strokeWidth={2} />
			<path
				d='M19.4697 11.841C19.7626 11.5481 20.2374 11.5481 20.5303 11.841L29.2197 20.5303C29.5126 20.8232 29.9874 20.8232 30.2803 20.5303C30.5732 20.2375 30.5732 19.7626 30.2803 19.4697L21.591 10.7803C20.7123 9.90167 19.2877 9.90167 18.409 10.7803L9.71967 19.4697C9.42678 19.7626 9.42678 20.2375 9.71967 20.5303C10.0126 20.8232 10.4874 20.8232 10.7803 20.5303L19.4697 11.841Z'
				fill='currentColor'
			/>
			<path
				d='M20 13.432L28.159 21.591C28.1887 21.6207 28.2191 21.6494 28.25 21.6772V27.875C28.25 28.9105 27.4105 29.75 26.375 29.75H23C22.5858 29.75 22.25 29.4142 22.25 29V24.5C22.25 24.0858 21.9142 23.75 21.5 23.75H18.5C18.0858 23.75 17.75 24.0858 17.75 24.5V29C17.75 29.4142 17.4142 29.75 17 29.75H13.625C12.5895 29.75 11.75 28.9106 11.75 27.875V21.6772C11.7809 21.6494 11.8113 21.6207 11.841 21.591L20 13.432Z'
				fill='currentColor'
			/>
		</svg>
	);
}
